<template>
  <b-modal v-model="isVisible" size="lg" hide-footer @hidden="onHidden">
    <b-card style="margin-bottom: 5px">
      
       <div class="mb-1 row p-1" v-if="dataProceso">
          <div class="col"><b>Procedimiento:</b> {{ dataProceso.procedimiento }}</div>
          <div class="col"><b>Paciente: </b> {{ dataProceso.paciente }}</div>
        </div>
      <h4 class="text-primary text-center mb-3">
        EVOLUCIÓN Y PRESCRIPCIONES
      </h4>


      <div class="d-flex justify-content-end">
        <b-button @click="setVisibleForm" variant="warning" class="mb-2">
          {{ viewForm ? 'Ocultar Formulario' : '+ Agregar Item' }}
        </b-button>
      </div>

      <div v-if="viewForm">

        <b-row>
          <b-col md="4">

            <b-row class="mb-1">
              <label class="col-4">Fecha: </label>
              <flat-pickr size="sm" class="form-control form-control-sm col-6" v-model="fechaActual" locale="es"
                :config="birthDateConfig" />
            </b-row>

            <b-row>
            
              <label class="col-4">Hora: </label>
                <vue-timepicker v-model="horaActual" fixed-dropdown-button format="HH:mm" manual-input>
              <template v-slot:dropdownButton>
                <i class="fa-regular fa-clock"></i>
              </template>

            </vue-timepicker>
              <!-- <b-timepicker class="col-6" v-model="horaActual" locale="es" format="HH:mm" size="sm" /> -->
            </b-row>
          </b-col>

          <b-col>
            <b-row class="mb-1">

              <label class="col-2">Doctor:</label>

              <SearchOpts class="col-10" v-model="doctor" :searchService="getDoctoresByEstablecimiento"
                :placeholder="'Buscar doctor...'" :minChars="3" />
            </b-row>

            <b-row>
              <label class="col-2">Auxiliar:</label>
              <SearchOpts v-model="auxiliar" :searchService="auxiliarService.searchAuxiliaresByTermSelect"
                :placeholder="'Buscar auxiliar...'" class="col-10" :minChars="3" />
            </b-row>
          </b-col>
        </b-row>

        <hr class="my-3" />

        <b-row>
          <label for="">Notas de Evolución:</label>
          <b-form-textarea v-model="notasEvolucion" />
        </b-row>

        <hr class="my-3" />
        <h5 class="text-center">Prescripciones</h5>

        <b-row class="mt-2">
          <label for="">Farmacoterapia e Indicaciones:</label>
          <b-form-textarea v-model="farmacoterapia" />

          <label class="mt-1">Administrar Farmacos Dispositivos:</label>
          <b-form-textarea v-model="dispositivo" />
        </b-row>

        <div class="d-flex justify-content-end mt-2">
          <b-button @click="onAddToTable" variant="info" size="sm">
            <span class="mr-1">Agregar</span>
            <i class="fa-solid fa-plus sm" />
          </b-button>
        </div>

      </div>

      <!-- <CardList/> -->

      <b-alert v-for="(item, index) in itemsTabla" :key="index" show :variant="getVariantCard(item.action)" 
        class="my-2 p-1">

        <div class="d-flex justify-content-end align-items-center ">
          <span class="mr-1">{{ item.action.toUpperCase() }}</span>
          <b-button class="mr-1" :variant="showCardComplete.includes(index) ? 'info' : ''" size="sm" @click="onViewItem(index)">
            <i class="fa-solid fa-magnifying-glass" />
          </b-button>

          <b-button class="mr-1" :variant="showCardComplete.includes(index) ? 'warning' : ''" size="sm" @click="onEditItem(index, item)">
            <i class="fa-solid fa-pencil" />
          </b-button>

          <b-button :variant="dark" title="Duplicar nota" size="sm" @click="duplicarEvol(item)">
            <i class="fa-solid fa-copy" />
          </b-button>

          <b-button v-if="item.action !== 'eliminar'" variant="danger" size="sm" class="ml-1"
            @click="onRemoveItemList(index)">
            <i class="fa-solid fa-x" />
          </b-button>

          <b-button v-if="item.action === 'eliminar'" variant="warning" size="sm" class="ml-1"
            @click="onRestoreItem(index)" title="Restaurar Item">
            <i class="fa-solid fa-rotate-right" />
          </b-button>
        </div>

        <b-row class="d-flex align-items-center mb-1">
          <strong class="col-3">Fecha y Hora: </strong>
          <span class="text-dark col">{{ item.fecha }} / {{ item.hora }}</span>
        </b-row>

        <b-row class="d-flex align-items-center mb-1">
          <strong class="col-3">Profesional: </strong>
          <span class="text-dark col">{{ getProfesional(item) }}</span> <br />
        </b-row>

        <span v-if="showCardComplete.includes(index)">
          <b-row class="d-flex align-items-center mb-1">
            <strong class="col-3">Notas de Evolucion: </strong>
            <span class="text-dark col">{{ item.notas }}</span> <br />
          </b-row>

          <b-row class="d-flex align-items-center mb-1">
            <strong class="col-3">Farmacoterapia e Indicaciones:: </strong>
            <span class="text-dark col">{{ item.farmacoterapia }}</span> <br />
          </b-row>

          <b-row class="d-flex align-items-center">
            <strong class="col-3">Dispositivo: </strong>
            <span class="text-dark col">{{ item.dispositivo }}</span>
          </b-row>
        </span>

      </b-alert>

      <EmptyResults v-if="!itemsTabla.length" message="No se ha registrado informacion" />

      <div v-if="itemsTabla.length" class="d-flex justify-content-end mt-2">
        <b-button variant="primary" @click="saveEvolucion">
          Guardar Evolucion
        </b-button>

        <b-button variant="secondary" class="ml-2">
          Cancelar
        </b-button>
      </div>

    </b-card>
    <div>
      <b-modal id="show-editar-evol" title="Editar Elemento" ok-title="Editar" @ok="editarEvol">
        <div class="row p-1 text-primary">
          <div class="col-6">
          <span>Fecha:</span>
           <flat-pickr size="sm" class="form-control form-control-sm " v-model="elementoSeleccionado.fecha" locale="es"
                :config="birthDateConfig" />
          </div>
          <div class="col-6">
          <span class="col-12">Hora:</span>
          <div class="mx-2" v-if="elementoSeleccionado.hora">
          <span>{{ elementoSeleccionado.hora }}</span> <b-button @click="elementoSeleccionado.hora = null" class="ml-2" size="sm" variant="danger"> <i class="fa-solid fa-trash"></i></b-button>
          </div>
           <vue-timepicker v-else  v-model="elementoSeleccionado.horaNueva" fixed-dropdown-button format="HH:mm" manual-input>
              <template v-slot:dropdownButton>
                <i class="fa-regular fa-clock"></i>
              </template>
           </vue-timepicker>
          </div>
        </div>
        <hr>
         <div class="row p-1 text-primary">
          <div class="col-12 mb-1">
          <span>Doctor</span>
            <SearchOpts class="col-10" v-model="elementoSeleccionado.doctor" :searchService="getDoctoresByEstablecimiento"
                :placeholder="'Buscar doctor...'" :minChars="3" />
          </div>
          <div class="col-12">
          <span>Auxiliar</span>
            <SearchOpts v-model="elementoSeleccionado.auxiliar" :searchService="auxiliarService.searchAuxiliaresByTermSelect"
                :placeholder="'Buscar auxiliar...'" class="col-10" :minChars="3" />
          </div>
        </div>
        <hr>
          <div class="row p-1 text-primary">
          <div class="col-12 mb-1">
          <span>Notas de Evolucion</span>
            <b-form-textarea v-model="elementoSeleccionado.notas"></b-form-textarea>
          </div>
          <div class="col-12 mb-1">
          <span>Farmacoterapia / Indicaciones</span>
             <b-form-textarea v-model="elementoSeleccionado.farmacoterapia"></b-form-textarea>
          </div>
          <div class="col-12">
          <span>Dispositivo</span>
             <b-form-textarea v-model="elementoSeleccionado.dispositivo"></b-form-textarea>
          </div>
        </div>
      </b-modal>
    </div>
  </b-modal>
  
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { SearchOpts, CardList, EmptyResults } from "@/shared/components";
import { doctoresService, auxiliarService } from "@/shared/services";
import { getEstablecimientoLS } from '@/shared/helpers';
import { procedimientosFormulariosService } from "../../services/procedimientosFormulariosService";
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'


export default {

  components: {
    flatPickr,
    SearchOpts,
    EmptyResults,
    VueTimepicker
  },


  data() {
    return {
      elementoSeleccionado: {
        fecha:null,
        hora:null,
        horaNueva:null,
        auxiliar:null,
        doctor:null,
        notas:null,
        farmacoterapia:null,
        dispositivo:null
      },
      isVisible: false,
      showCardComplete: [],

      viewForm: false,

      doctoresService,
      auxiliarService,
      notasEvolucion: null,
      farmacoterapia: null,
      doctor: null,
      auxiliar: null,
      dispositivo: null,
      profesional: null,
      fechaActual: null,
      horaActual: null,
      birthDateConfig: {
        allowInput: true,
        dateFormat: "Y-m-d", // Solo fecha
      },
      procedimiento: [],

      itemsTabla: [],

      fields: [
        {
          key: "fecha",
          label: "Fecha",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },
        { key: "hora", label: "Hora", sortable: true, thClass: "text-center" },
        {
          key: "notas",
          label: "Notas",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },
        {
          key: "profesional",
          label: "Profesional",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },
        {
          key: "farmacoterapia",
          label: "Farmacoterapia",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },
        {
          key: "dispositivo",
          label: "Dispositivo",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },
        {
          key: "acciones",
          label: "",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },
      ],


    };
  },

  props:{
    dataProceso:{
      default:null,
      required:false
    }
  },

  created() {

    this.getData()

    // Preestablecer fecha y hora de hoy
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0"); // Meses van de 0 a 11
    const day = String(now.getDate()).padStart(2, "0");
    this.fechaActual = `${year}-${month}-${day}`
    this.horaActual = now.getHours() + ":" + ("0" + now.getMinutes()).slice(-2); // Formateamos la hora
  },

  methods: {

   editarEvol() {
  let index = this.elementoSeleccionado.index;
  this.elementoSeleccionado.action = 'editado';
  if (this.elementoSeleccionado.horaNueva && this.elementoSeleccionado.horaNueva.HH) {
    this.elementoSeleccionado.hora = `${this.elementoSeleccionado.horaNueva.HH}:${this.elementoSeleccionado.horaNueva.mm}`
  }

  // Reemplazar el elemento de forma reactiva
  this.itemsTabla.splice(index, 1, { ...this.elementoSeleccionado });

  // Opcional: limpiar selección
  this.elementoSeleccionado = {
    fecha: null,
    hora: null,
    horaNueva: null,
    auxiliar: null,
    doctor: null,
    notas: null,
    farmacoterapia: null,
    dispositivo: null,
    index: null
  };
},

duplicarEvol(it) {
  let item = {...it}
  item.action = 'duplicado';
  
  this.itemsTabla.push({ ...item });

},


    async getData() {

      this.tokenProceso = this.$route.query.forms;
      if (!this.tokenProceso) return;

      const tokenFormulario = this.$route.query.f005;

      console.log("token formulario", tokenFormulario)

      const responseGet = await procedimientosFormulariosService.obtenerFormProcDataByToken(tokenFormulario);

      console.log("response get", responseGet)

      if (!responseGet) {
        this.isVisible = true;
        return;
      }

      const dataF005 = responseGet;
      this.idRegistroForm = dataF005.id;
      //delete dataF005.id;

      const jsonData = JSON.parse(dataF005.dataJson)

      console.log("json data f005", jsonData)

      const dataTable005 = jsonData;

      const dataMap = dataTable005.map(d => ({
        ...d,
        action: 'registrado'
      }));

      this.itemsTabla = dataMap;

      this.isVisible = true
    },


    onHidden() {
      this.isVisible = false;
      this.itemsTabla = []
    },


    setVisibleForm() {
      this.viewForm = !this.viewForm
    },


    onViewItem(index) {
      const exists = this.showCardComplete.includes(index)

      this.showCardComplete = exists
        ? this.showCardComplete.filter(item => item !== index)
        : [...this.showCardComplete, index];
    },

    onEditItem(index, item){

 console.log("item seleccionado", item, index)
      this.elementoSeleccionado.doctor=item?.doctor
      this.elementoSeleccionado.auxiliar=item?.auxiliar
      this.elementoSeleccionado.action = item?.action
      this.elementoSeleccionado.dispositivo = item?.dispositivo
      this.elementoSeleccionado.farmacoterapia = item?.farmacoterapia
      this.elementoSeleccionado.notas = item?.notas
      this.elementoSeleccionado.fecha = item?.fecha
      this.elementoSeleccionado.hora = item?.hora
      this.elementoSeleccionado.index = index
      


     
      this.$bvModal.show("show-editar-evol");
    },



    async getDoctoresByEstablecimiento(search) {
      const establecimiento = getEstablecimientoLS();
      const responseDoctores = await doctoresService.searchDoctoresByTermSelect(search, establecimiento.id);

      const responseMap = responseDoctores.map(item => ({
        value: item.value,
        text: item.text,
        especialidad: item.especialidad
      }));

      return responseMap;
    },


    async onRemoveItemList(index) {

      const result = await this.$swal.fire({
        title: 'Eliminar Item Examen',
        text: "Estas seguro de eliminar este examen?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, Eliminar!',
        cancelButtonText: 'Cancelar',
      });

      if (!result.isConfirmed) return;

      if (this.itemsTabla[index].action === 'registrado') {
        this.itemsTabla[index].action = 'eliminar';
        return;
      }

      this.itemsTabla.splice(index, 1)
    },


    onRestoreItem(index) {
      this.itemsTabla[index].action = 'registrado'
    },


    getVariantCard(action) {
      let variant = 'info'
      if (action === 'resgistrado') { variant = 'success'}
      if (action === 'editado') { variant = 'warning'}
      if (action === 'eliminar') { variant = 'danger'}
      if (action === 'duplicado') { variant = 'secondary'}


      
      return variant;
    },


    formatTime(time) {
      if (!time) return ""; // Si no hay fecha, retorna una cadena vacía
      const pieces = time.split(':')
      const timeFormatted = pieces[0] + ":" + pieces[1]
      return `${timeFormatted}`;
    },

    onAddToTable() {

      if (
        (!this.doctor && !this.auxiliar)
        || !this.fechaActual
        || !this.notasEvolucion
        || !this.horaActual
      ) {
        this.$swal.fire({
          icon: "info",
          text: "Por favor, ingrese los datos requeridos."
        })
        return;
      }


      this.itemsTabla.push({
        fecha: this.fechaActual,
        hora:  this.horaActual.HH ? `${this.horaActual.HH}:${this.horaActual.mm}` : this.horaActual ,
        notas: this.notasEvolucion,
        doctor: this.doctor,
        auxiliar: this.auxiliar,
        farmacoterapia: this.farmacoterapia,
        dispositivo: this.dispositivo,
        action: 'crear'
      });

      this.clearForm();
    },


    async saveEvolucion() {
      // const itemsTable = localStorage.getItem("tablaEvoluciones");

      const itemsTable = this.itemsTabla

      if (!itemsTable || !itemsTable.length) {
        await this.$swal.fire({
          icon: "warning",
          text: "No se guardó, data inexistente.",
        });
        return;
      }


      const itemsFiltered = itemsTable.filter(item => item.action !== 'eliminar');

      const params = {
        nameForm: "005",
        dataJson: JSON.stringify(itemsFiltered),
        tokenProceso: this.tokenProceso,
        idRegistroForm: this.idRegistroForm,
      }

      const responseSave = await procedimientosFormulariosService.guardarData(params);

      if (!responseSave) {
        this.$swal({
          title: "Error",
          text: "Ocurrio un error al guardar",
          icon: "error",
          confirmButtonColor: "#089599",
        });

        return;
      }

      await this.$swal.fire({
        title: "Guardado correctamente",
        icon: "success",
      });
      this.$emit("formulario-guardado");
      this.isVisible = false;
    },

    getProfesional(dataItem) {

      const { doctor, auxiliar } = dataItem

      const profesional = (doctor && auxiliar)
        ? `${doctor.text} / ${auxiliar.text}`
        : (doctor)
          ? `${doctor.text}`
          : (auxiliar)
            ? `${auxiliar.text}`
            : "";

      return profesional
    },

    clearForm() {
      this.doctor = null;
      this.auxiliar = null;
      this.fechaActual = null;
      this.horaActual = null;
      this.notasEvolucion = null;
      this.farmacoterapia = null;
      this.dispositivo = null;
      this.viewForm = false
    }
  },

  watch: {

    '$route.query.f005': {
      handler(newValue) {
        if (newValue) {
          this.getData();
        }
      },
    },

    isVisible: {
      deep: true,
      handler(newValue) {
        if (!newValue) {
          const updatedQuery = { ...this.$route.query };
          delete updatedQuery.f005;
          this.$router.push({ path: this.$route.path, query: updatedQuery });
        }
      }
    }

  },


};
</script>

<style scoped>
.flatpickr-input {
  font-size: 0.85rem;
  padding: 0.25rem 0.5rem;
}
</style>
